export default __webpack_public_path__ + "static/media/model-eyes.99de434b.webp";